import { useCreditCard } from "@/hooks/useCreditCard";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "@/utils";
import { TrashIcon2 } from "@/styles/icons/TrashIcon2";
import { useAsyncFunction } from "@/hooks/useAsyncFunction";
import { Button, Modal } from "barte-design-system";
import { Text } from "@chakra-ui/react";

interface DeleteCreditCardProps {
    isOpen: boolean;
    onClose: ()=> void;
}
export default function DeleteCreditCard({isOpen, onClose}: DeleteCreditCardProps) {
    const { deleteCreditCard } = useCreditCard();
    const { id } = useParams();
    const navigate = useNavigate();
    const { execute, loading } = useAsyncFunction(deleteCreditCard);

    async function onSubmit() {
        try {
            await execute(id);
            navigate("/cartao");
            showToast({ type: "success", message: `Cartão deletado com sucesso.` });
        } catch (error) {
            error?.response?.data?.errors.map((error) => {
                showToast({ type: "error", message: `${error?.code} - ${error?.description}` });
            });
        } finally {
            onClose();
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            title="Cancelar cartão"
            onClose={onClose}
            footer={{
                primaryButton: { children: "Cancelar cartão", onClick: onSubmit, loading, disabled: loading },
                secondaryButton: { children: "Voltar", onClick: onClose, variant: "outline" },
            }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                <TrashIcon2 />
                <Text fontSize="14px">Você quer cancelar esse cartão definitivamente?</Text>
                <Text fontSize="14px">Qualquer recorrência futura ou compra que ainda não tenha sido aprovada com esse cartão, não será aprovada.</Text>
                <Text fontSize="12px" color="red.400" fontWeight={600}>Essa ação não poderá ser desfeita.</Text>
            </div>
        </Modal>
    );
}
